import { Badge as AntdBadge, BadgeProps } from 'antd'

export const Badge = (args: Omit<BadgeProps, 'style'>) => {
  return (
    <AntdBadge
      {...args}
      style={{
        boxShadow: 'none',
        height: 'fit-content',
        padding: '3px 8px', // more generous padding than antd's default
      }}
    />
  )
}
